import React, { useEffect } from 'react';
import { Map } from 'immutable';
import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';

import {
  Node,
  entityGetByPath,
  referenceLoadingReset,
  I18nProvider,
} from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';
import { usePrevious } from '../../hooks/usePrevious';

import { __DEBUG__, NODE_TYPES_WITHOUT_PAGE } from '../../config/constants';
import Page from '../Page';
import NotFound from '../NotFound';

import {
  Debug,
} from '../../components';
import Cookie from '../../components/Cookie';

import {
  Navigation,
  Footer,
} from '../../implementations';

import i18next from '../../config/i18next';

import '../../styles/main.scss';
import './style.scss';

const App = () => {
  const dispatch = useDispatch();
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const childEntity = useSelector((state) => state.getIn([entityType, entityId], Map()));
  const entityBundle = childEntity.getIn(['type', 0, 'target_id']);
  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const rootClasses = useSelector((state) => state.getIn(['ui', 'rootClasses']));
  const entityStatus = useSelector((state) => state.getIn(['entity', 'status']));
  const entityExists = useSelector((state) => state.getIn(['entity', 'exists']));
  const language = useSelector((state) => state.getIn(['ui', 'language']));

  const entityTypeTarget = useSelector((state) => state.getIn(['node', entityId, 'type', '0', 'target_id'], null));

  // TODO: add check of is municipality node in app
  // const municipalityItems = useSelector((state) => state.getIn(['node', entityId, 'field_municipality'], null));

  // let isMunicipality;

  // if (entityTypeTarget === 'municipality' || municipalityItems > 0) {
  //   console.log('this is a municipality node');
  //   isMunicipality = true;
  // }

  const prevPath = usePrevious(path);

  useEffect(() => {
    if (!entityType || !entityId) {
      dispatch(entityGetByPath(path));
    }

    if (path !== prevPath) {
      dispatch(referenceLoadingReset());
      dispatch(entityGetByPath(path));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityType, entityId, path]);


  const renderPage = () => {
    if (entityStatus === 404) {
      return (
        <Container>
          <NotFound />
        </Container>
      );
    }

    return (
      <Page title={childEntity.getIn(['title', 0, 'value'], '')} className={`Page__type-${entityBundle}`} type={entityBundle}>
        {entityType === 'node' && !NODE_TYPES_WITHOUT_PAGE.includes(entityBundle) && (
          <Node root id={entityId} />
        )}
      </Page>
    );
  };

  const classes = classNames('App', rootClasses.join(' '), {
    'is-front-page': childEntity.get('is_front'),
    'not-found': !entityExists,
  });

  if ((!entityType || !entityId) && entityExists) {
    return null;
  }

  return (
    <I18nProvider locale={language} i18next={i18next}>
      <div className={classes} language={language}>
        <header>
          <Navigation path={path} entityId={entityId} entityTypeTarget={entityTypeTarget} />
        </header>
        <main className="main">
          {renderPage()}
        </main>
        <footer>
          <Footer entityId={entityId} entityTypeTarget={entityTypeTarget} />
        </footer>
        {__DEBUG__ && <Debug />}
        <Cookie />
        <div id="modal-root" />
      </div>
    </I18nProvider>
  );
};

export default App;
